/**
 * Custom error class for decryption failures.
 * Used to distinguish decryption errors from other errors and provide context.
 */
class DecryptionError extends Error {
    constructor(message, electionId = null, attemptedWith = null) {
        super(message);
        this.name = 'DecryptionError';
        this.electionId = electionId;
        this.attemptedWith = attemptedWith; // 'localStorage', 'url', or 'both'

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, DecryptionError);
        }
    }
}

export default DecryptionError;
